const industries = [
  {
    icon: "ri-building-2-line",
    label: "Construction",
    tagline: "Project delivery at scale",
    challenges: ["Missed calls & follow-ups", "Scheduling gaps", "Multi-team coordination"],
    color: "#EEF2FF",
    borderColor: "#C7D2FE",
    imgSrc: "https://public.readdy.ai/ai/img_res/ccb2661f5c6e77b3b7c8011d7d1c8b33.jpg",
  },
  {
    icon: "ri-scales-3-line",
    label: "Legal",
    tagline: "Intake to resolution, automated",
    challenges: ["Client intake & onboarding", "Documentation workflows", "Follow-up management"],
    color: "#F0FDF4",
    borderColor: "#BBF7D0",
    imgSrc: "https://readdy.ai/api/search-image?query=clean%20minimal%20modern%20law%20office%20interior%20white%20walls%20organized%20bookshelves%20law%20books%20elegant%20wooden%20desk%20natural%20window%20light%20premium%20professional%20environment%20no%20people%20focused%20workspace%20cream%20white%20tones%20high%20end%20interior%20design&width=600&height=340&seq=noveka-ind-legal-2&orientation=landscape",
  },
  {
    icon: "ri-heart-pulse-line",
    label: "Clinical",
    tagline: "Patient-first operations",
    challenges: ["Patient intake & scheduling", "Communication workflows", "Compliance tracking"],
    color: "#FFF7ED",
    borderColor: "#FED7AA",
    imgSrc: "https://readdy.ai/api/search-image?query=modern%20minimal%20clinical%20medical%20office%20interior%20clean%20white%20walls%20organized%20reception%20area%20soft%20natural%20lighting%20premium%20healthcare%20environment%20no%20people%20calm%20professional%20atmosphere%20white%20light%20gray%20clean%20sterile%20modern&width=600&height=340&seq=noveka-ind-clinical-2&orientation=landscape",
  },
  {
    icon: "ri-ruler-line",
    label: "Engineering & Architecture",
    tagline: "Precision from plan to delivery",
    challenges: ["Project workflow management", "Approval chains", "Data handling & reporting"],
    color: "#F5F3FF",
    borderColor: "#DDD6FE",
    imgSrc: "https://readdy.ai/api/search-image?query=modern%20architecture%20engineering%20studio%20office%20interior%20with%20large%20drawings%20blueprints%20spread%20on%20white%20desk%20natural%20light%20floor%20to%20ceiling%20windows%20clean%20minimal%20workspace%20professional%20design%20studio%20no%20people%20white%20gray%20tones%20precise%20organized&width=600&height=340&seq=noveka-ind-engineering-2&orientation=landscape",
  },
];

export default function IndustryApplications() {
  return (
    <section
      id="industries"
      className="bg-white py-28 px-6 md:px-10"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <p className="text-xs font-medium text-[#4F46E5] uppercase tracking-widest mb-4">
            Industry Applications
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-[#1F2933] tracking-[-0.03em] leading-[1.08]">
            Built for Real-World
            <br />
            <span className="text-[#6B7280] font-normal">Operations.</span>
          </h2>
          <p className="text-sm md:text-base text-[#6B7280] mt-5 max-w-xl mx-auto leading-relaxed">
            Every system Noveka AI deploys is tailored to the specific friction points of your industry.
          </p>
        </div>

        {/* Cards with images */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {industries.map((ind) => (
            <div
              key={ind.label}
              className="group rounded-[20px] border border-[#E5E7EB] bg-white overflow-hidden hover:shadow-[0_10px_40px_rgba(0,0,0,0.09)] hover:-translate-y-1.5 transition-all duration-300 cursor-pointer"
            >
              {/* Cover image */}
              <div className="w-full h-48 overflow-hidden bg-[#F7F8FA]">
                <img
                  src={ind.imgSrc}
                  alt={ind.label}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-7">
                <div className="flex items-start gap-3 mb-5">
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-[10px] border shrink-0"
                    style={{ background: ind.color, borderColor: ind.borderColor }}
                  >
                    <i className={`${ind.icon} text-lg text-[#4F46E5]`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1F2933] leading-snug">{ind.label}</h3>
                    <p className="text-xs text-[#6B7280] mt-0.5">{ind.tagline}</p>
                  </div>
                </div>

                <ul className="flex flex-col gap-2.5">
                  {ind.challenges.map((c) => (
                    <li key={c} className="flex items-center gap-2.5">
                      <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#F7F8FA] border border-[#E5E7EB] shrink-0">
                        <i className="ri-check-line text-[10px] text-[#4F46E5]"></i>
                      </div>
                      <span className="text-xs text-[#6B7280] leading-relaxed">{c}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
